// extracted by mini-css-extract-plugin
export default {"leftDivider":"OneFlightOrder_leftDivider__uz9AC"};